"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAdmin = createAdmin;
exports.deleteAdmin = deleteAdmin;
exports.getLangCode = getLangCode;
exports.listAdmin = listAdmin;
exports.readminAdmin = readminAdmin;
exports.updateAdmin = updateAdmin;
var _request = _interopRequireDefault(require("@/utils/request"));
function listAdmin(query) {
  return (0, _request.default)({
    url: '/admin/list',
    method: 'get',
    params: query
  });
}
function createAdmin(data) {
  return (0, _request.default)({
    url: '/admin/create',
    method: 'post',
    data: data
  });
}
function readminAdmin(data) {
  return (0, _request.default)({
    url: '/admin/readmin',
    method: 'get',
    data: data
  });
}
function updateAdmin(data) {
  return (0, _request.default)({
    url: '/admin/update',
    method: 'post',
    data: data
  });
}
function deleteAdmin(data) {
  return (0, _request.default)({
    url: '/admin/delete',
    method: 'post',
    data: data
  });
}
function getLangCode(data) {
  return (0, _request.default)({
    url: '/translate/getLangCode',
    method: 'get',
    data: data
  });
}